var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    solutions: _vm.isSolutionVisible,
    'solutions--hidden': !_vm.isSolutionVisible,
  }},[_c('div',{staticClass:"solution__professor"},[_c('div',{staticClass:"grid"},[_vm._t("header")],2)]),(_vm.isSolutionVisible)?_c('div',{staticClass:"solutions__comments"},[_c('div',{staticClass:"grid"},[_vm._t("body")],2)]):_vm._e(),(_vm.isObjectiveTrivia)?_c('div',{staticClass:"solutions__button"},[_c('div',[_vm._t("button")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }